// extracted by mini-css-extract-plugin
export default {"wrap":"Textarea_wrap__GWG+O","wrap__label":"Textarea_wrap__label__C6wf4","wrap__textarea":"Textarea_wrap__textarea__0sLUX"};